export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00428.54d0690a.png";